import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestRoundupLawyersWrapper from "@components/layouts/bestrounduplawyersWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function BestRoundupLawyersHome(): ReactElement {
    return (
        <BestRoundupLawyersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="Paraquat"
                    domain="BestRoundupLawyers.com"
                />
            </div>
        </BestRoundupLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
